import Conf from 'ui-config'
import axios from 'axios'

export const AuthAPI = {
  init: async function (params) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/init', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(params),
    })
  },
  login: async function (params) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(params),
    })
  },
  logout: async function (params) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/users/logout', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
      data: params,
    })
  },
  // invalidate: async function(ssid) {
  //   return await axios(Conf.HOST_S + Conf.CORE_IP + '/api/session/invalidate', {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json',
  //       SSID: ssid,
  //     },
  //     data: {},
  //   })
  // },
  invalidate: async function (params) {
    return await axios(
      Conf.HOST_S + Conf.CORE_IP + '/' + params.clusterId + '/api/session/invalidate',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          SSID: params.SSID,
        },
        data: {},
      })
  },
  getIdFromToken: async function (token) {
    return await axios(
      Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/verify-pass-token/' + token,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    )
  },
  setPassword: async function (params) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/set_pass', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: params,
    })
  },
  resetPassword: async function () {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/reset_pass', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  },

  clusters: async function (ssid) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/cluster/list', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
    })
  },
}
export default AuthAPI
